import React from "react";
import { Box, Typography } from "@mui/material";
import { MyBarChartIcon } from "../../Assets/svg/MyIcons";

const NoDataFound = ({ message = "No data available for the selected filters", icon }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
      }}
    >
      {icon || <MyBarChartIcon sx={{ fontSize: 60, color: "#ccc", mb: 2 }} />}
      <Typography variant="h6" color="text.secondary" align="center">
        {message}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
        Try changing your filters or selecting a different date range
      </Typography>
    </Box>
  );
};

export default NoDataFound; 